import { render, staticRenderFns } from "./CustomizeMetalP.vue?vue&type=template&id=44d820ba&scoped=true"
import script from "./CustomizeMetalP.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalP.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalP.vue?vue&type=style&index=0&id=44d820ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d820ba",
  null
  
)

export default component.exports